import React, { Component } from 'react'
import { Menu, Icon } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

const propTypes = {
  subpages: PropTypes.object.isRequired
}
class PageMobileNav extends Component {
  renderMenuItems = subpages => {
    const menuItems = Object.keys(subpages).map(page => {
      return (
        <Menu.Item
          link
          key={subpages[page].label}
          name={subpages[page].path}
          as={NavLink}
          exact
          to={subpages[page].path}
        >
          <Icon name={subpages[page].icon} src={subpages[page].path} />{' '}
          {subpages[page].label}
        </Menu.Item>
      )
    })
    return menuItems
  }

  render() {
    const { subpages } = this.props
    return (
      <div>
        {<Menu.Item as="a" header id="menu-link">
          <a href="https://www.facebook.com/Slikopleskarstvo-in-suhomonta%C5%BEa-Cvetek-475761759163471/?fref=ts">
            <Icon size="big" name="facebook" /></a>
        </Menu.Item>}
        {this.renderMenuItems(subpages)}
      </div>
    )
  }
}

PageMobileNav.propTypes = propTypes
export default PageMobileNav



// WEBPACK FOOTER //
// ./src/components/PageMobileNav.js